import {Pais} from './pais.model';
import {OrigenDeFondos} from './origen-de-fondos.model';
import {TipoSujetoObligado} from './tipo-sujeto-obligado.model';
import {Moneda} from './moneda.model';
import {SectorActividad} from './sector-actividad.model';


export class PonderacionDeRiesgos {

    id: number;
    nombre: string;
    origenDeFondos: number;
    paisDeResidenciaDelCliente: number;
    paisDeResidenciaDelBeneficiario: number;
    paisDeResidenciaDelRelacionado: number;
    paisDeOperacion: number;
    pep: number;
    tipoDeSujetoObligado: number;
    umbralServicio: number;
    moneda: number;
    sectorDeActividad: number;
    toleranciaAlRiesgo: number;
    bloqueado: boolean;
    
    /**
     * Constructor
     *
     * @param tipoOperacion
     */
    constructor(tipoOperacion)
    {
        {
            this.id = tipoOperacion.id || null;
            this.nombre = tipoOperacion.nombre || '';
            this.origenDeFondos = tipoOperacion.origenDeFondos;
            this.paisDeResidenciaDelCliente = tipoOperacion.paisDeResidenciaDelCliente;
            this.paisDeResidenciaDelBeneficiario = tipoOperacion.paisDeResidenciaDelBeneficiario;
            this.paisDeResidenciaDelRelacionado = tipoOperacion.paisDeResidenciaDelRelacionado;
            this.paisDeOperacion = tipoOperacion.paisDeOperacion;
            this.pep = tipoOperacion.pep || false;
            this.tipoDeSujetoObligado = tipoOperacion.tipoDeSujetoObligado;
            this.umbralServicio = tipoOperacion.umbralServicio || 0;
            this.moneda = tipoOperacion.moneda;
            this.sectorDeActividad = tipoOperacion.sectorDeActividad;
            this.toleranciaAlRiesgo = tipoOperacion.toleranciaAlRiesgo || 0;
            this.bloqueado = tipoOperacion.nombre || false;
            
        }
    }
}
